import { routes } from "../../routes/index";
import {
  Box,
  Button,
  Flex,
  Input,
  Text,
  useClipboard,
  VStack,
  Link,
  useToast,
} from "@chakra-ui/react";
import { useLocation, useNavigate } from "react-router-dom";

export default function ShareLinkPage() {
  const location = useLocation();
  const toast = useToast();

  const linkToCopy = `
    https://minhabiometria.com.br/${location?.state?.proposal?.UnicoData?.id}
  `;

  const { hasCopied, onCopy } = useClipboard(linkToCopy);
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate(
      routes.find((route) => route.name === "proposals-page")?.path || "/"
    );
  };
  const handleCopy = () => {
    onCopy();
    toast({
      title: "Link copiado!",
      description: "O link foi copiado para sua área de transferência",
      status: "success",
      duration: 3000,
      isClosable: true,
      position: "top",
    });
  };

  return (
    <Flex
      justify="center"
      align="center"
      w="100%"
      bg="gray.100"
      minH="100vh"
      p={{ base: 3, md: 6 }}
      mt={{ base: "-5vh", md: "-10vh" }}
    >
      <VStack
        spacing={{ base: 5, md: 8 }}
        p={{ base: 5, md: 10 }}
        boxShadow="2xl"
        borderRadius="lg"
        bg="white"
        w={{ base: "95%", md: "50%", lg: "40%" }}
      >
        <Text
          fontSize={{ base: "2xl", md: "2xl" }}
          fontWeight="bold"
          color="gray.700"
          textAlign="center"
          fontFamily="Lexend Deca"
        >
          Sua proposta foi concluída com sucesso!
        </Text>

        <Text
          fontSize={{ base: "lg", md: "lg" }}
          color="gray.600"
          textAlign="center"
          fontFamily="Lexend Deca"
        >
          Envie o LINK abaixo ao seu cliente para ele realizar a formalização
          digital.
        </Text>

        <Box w="100%" position="relative">
          <Input
            value={linkToCopy}
            isReadOnly
            size={{ base: "md", md: "lg" }}
            borderColor="gray.300"
            _focus={{
              borderColor: "green.500",
              boxShadow: "0 0 0 1px green.500",
            }}
            bg="gray.50"
            borderRadius="md"
            p={{ base: 3, md: 5 }}
            pr={{ base: "90px", md: "100px" }}
            overflow="hidden"
            textOverflow="ellipsis"
            whiteSpace="nowrap"
          />
          <Button
            onClick={handleCopy}
            position="absolute"
            right={2}
            top="50%"
            transform="translateY(-50%)"
            fontFamily="Lexend Deca"
            colorScheme="green"
            size={{ base: "sm", md: "sm" }}
            minW={{ base: "80px", md: "90px" }}
          >
            {hasCopied ? "Copiado!" : "Copiar"}
          </Button>
        </Box>

        <Link
          onClick={handleRedirect}
          color="green.500"
          fontFamily="Lexend Deca"
          fontWeight="bold"
          fontSize={{ base: "md", md: "md" }}
        >
          Clique aqui e acompanhe as Propostas
        </Link>
      </VStack>
    </Flex>
  );
}
